// src/config.ts
export interface AppConfig {
  CLERK_PUBLISHABLE_KEY: string;
  API_URL?: string;
  GOOGLE_MAPS_API_KEY: string;
  GOOGLE_MAPS_MAP_ID?: string;
  ENVIRONMENT?: string;
}

export const getConfig = (): AppConfig => {
  if (!window.ENV) {
    throw new Error('Runtime config (window.ENV) has not been loaded yet. Make sure loadConfig() ran before using getConfig().');
  }
  return window.ENV;
};

// Optional: Simple version if you prefer direct access
export const config = {
  get clerkPublishableKey() { return window.ENV?.CLERK_PUBLISHABLE_KEY; },
  get apiUrl() { return window.ENV?.API_URL; },
  get googleMapsApiKey() { return window.ENV?.GOOGLE_MAPS_API_KEY; },
  get environment() { return window.ENV?.ENVIRONMENT; },
};